import { getPatternStyles, patternFns } from './runtime.mjs';
import { memo } from '../helpers.mjs';
import { css } from '../css/index.mjs';

const vstackConfig = {
  transform(props) {
    const { justify, gap, ...rest } = props;
    return {
      display: "flex",
      alignItems: "center",
      justifyContent: justify,
      gap,
      flexDirection: "column",
      ...rest
    };
  },
  defaultValues: { gap: "0" }
}

export function vstackRaw(styles) {
  const s = getPatternStyles(vstackConfig, styles || {})
  return vstackConfig.transform(s, patternFns)
}

export const vstack = /* @__PURE__ */ Object.assign(/* @__PURE__ */ memo(function vstack(styles = {}) {
  return css(vstackRaw(styles))
}), { raw: vstackRaw, propKeys: ["gap","justify"] })